import React, { useCallback, useMemo, useReducer } from 'react';
import PropTypes from 'prop-types';
import { trackV2 } from 'utils/analytics';
import InviteFriendsContext from '../../state/InviteFriendsContext';
import { reducer } from '../../state/InviteFriends.reducer';
import FacebookTabContent from '../InviteFriendsModal/components/FacebookTabContent';

const FacebookReactPanel = ({
  source,
  currentAthlete,
  locale,
  fbAppId,
  fbVersion,
  defaultTab
}) => {
  const track = useCallback(
    (fields) => {
      trackV2({
        page: 'find_and_invite',
        category: 'connections',
        ...fields,
        properties: {
          source,
          default_tab: defaultTab,
          ...fields.properties
        }
      });
    },
    [defaultTab, source]
  );

  const [state, dispatch] = useReducer(reducer, {
    currentAthlete,
    fbAppId,
    fbVersion,
    locale,
    fbFriends: {},
    alert: {},
    modalTabIndex: 1 // fake it till you make it (need this for the initial requestFriends call)
  });

  const providerState = useMemo(
    () => ({
      state,
      dispatch,
      track
    }),
    [state, track]
  );

  return (
    <InviteFriendsContext.Provider value={providerState}>
      <FacebookTabContent />
    </InviteFriendsContext.Provider>
  );
};

FacebookReactPanel.propTypes = {
  source: PropTypes.oneOf([
    'onboarding', // facebook button on onboarding dashboard feed
    'dashboard_sidebar',
    'athlete_search',
    'follows_following',
    'header_menu',
    'follows_suggested'
  ]).isRequired,
  fbAppId: PropTypes.number.isRequired,
  fbVersion: PropTypes.string.isRequired,
  currentAthlete: PropTypes.shape({
    id: PropTypes.number.isRequired
  }).isRequired,
  locale: PropTypes.string.isRequired,
  defaultTab: PropTypes.oneOf(['email', 'facebook']).isRequired
};

export default FacebookReactPanel;
